// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-content[data-v-607a3e79]{--columns:1}@media(min-width:768px){.profile-content[data-v-607a3e79]{--columns:2}}", ""]);
// Exports
module.exports = exports;
